module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('y-header'), _vm._v(" "), _c('router-view', {
    staticClass: "main"
  }), _vm._v(" "), _c('y-footer'), _vm._v(" "), _c('transition', {
    on: {
      "after-enter": _vm.afterEnter,
      "before-enter": _vm.beforeEnter
    }
  }, [(_vm.showMoveImg) ? _c('div', {
    staticClass: "move_img",
    style: ({
      left: (_vm.cartPositionL - 10) + 'px',
      top: (_vm.cartPositionT - 10) + 'px'
    })
  }, [_c('div', [_c('img', {
    attrs: {
      "src": _vm.moveImgUrl
    }
  })])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-776f8f27","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/index.vue
// module id = 490
// module chunks = 11